module.exports = __webpack_public_path__ + "static/media/paper24.48e19827.jpg";